import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { LocalStorageFacade } from '@application/localstorage';
import { APP_CONFIG, resolveOriginsByConfig } from '@application/config';
import { IAuthAccessToken } from '@auth/data-access';
import { IUser, IUserRole, UserProfile } from '../entities/self-user.types';

@Injectable({ providedIn: 'root' })
export class SelfUserApiService {
  private readonly http = inject(HttpClient);
  private readonly localStorageService = inject(LocalStorageFacade);
  private readonly appConfig = inject(APP_CONFIG);
  private readonly apiUrl = this.appConfig.apiUrl;

  public getSelfUser(): Observable<IUser> {
    const authorization = this.getAuthorization();
    if (!authorization?.PersonId) {
      return throwError(() => new Error('AUTH_REQUIRED'));
    }

    return this.http.get<IUser>(
      this.apiUrl.userService + '/UserProfile?id=' + authorization.PersonId,
      { withCredentials: true }
    );
  }

  public getSelfUserRole(): Observable<IUserRole> {
    const authorization = this.getAuthorization();
    if (!authorization?.PersonId) {
      return throwError(() => new Error('AUTH_REQUIRED'));
    }

    return this.http.get<IUserRole>(
      this.apiUrl.userService + '/Role?id=' + authorization.PersonId,
      { withCredentials: true }
    );
  }

 private getAuthorization(): IAuthAccessToken | null {
    const raw = this.localStorageService.getItem('authorization');
    try {
      return raw ? (JSON.parse(raw) as IAuthAccessToken) : null;
    } catch {
      return null;
    }
  }

  public getSelfUserProfile(): Observable<UserProfile> {
    return this.http.get<UserProfile>(
      `${this.apiUrl.userService}/UserProfile/GetByAuthPersonAsync`,
      { withCredentials: true }
    );
  }

  public getAllPersonsByUser(): Observable<IUserRole[]> {
    const origins = resolveOriginsByConfig(this.appConfig);

    return this.http.get<IUserRole[]>(
      `${this.apiUrl.userService}/UserProfile/GetAllPersonsByUser`,
      {
        params: { origins },
        withCredentials: true,
      }
    );
  }
}
